import { render, staticRenderFns } from "./starshop-discrepancy-transaction-action-column.vue?vue&type=template&id=1b55be80&scoped=true"
import script from "./starshop-discrepancy-transaction-action-column.vue?vue&type=script&lang=js"
export * from "./starshop-discrepancy-transaction-action-column.vue?vue&type=script&lang=js"
import style0 from "./starshop-discrepancy-transaction-action-column.vue?vue&type=style&index=0&id=1b55be80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55be80",
  null
  
)

export default component.exports